import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-508aee81"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "d-flex align-items-center justify-content-between card-title m-0 w-100" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "row mb-6" }
const _hoisted_15 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_16 = { class: "col-lg-8 fv-row" }
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_20 = {
  type: "reset",
  class: "btn btn-white btn-active-light-primary me-2"
}
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "indicator-label" }
const _hoisted_23 = { class: "indicator-progress" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_25 = {
  key: 0,
  class: "m-5"
}
const _hoisted_26 = { class: "fw-bolder my-5 mx-5 p-5 border-top" }
const _hoisted_27 = { class: "d-flex align-items-center flex-wrap" }
const _hoisted_28 = ["href"]
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  key: 0,
  class: "py-2 fs-8",
  style: {"white-space":"nowrap"}
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 1,
  class: "m-5 d-flex align-items-center flex-wrap"
}
const _hoisted_33 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('Attachments')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Form, {
        class: "form",
        "validation-schema": _ctx.attachmentSchema,
        onSubmit: _ctx.onSubmitCreateAttachment
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(_ctx.translate('Documents')), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Field, {
                  as: "select",
                  name: "documentTypeId",
                  class: "form-select form-select-solid form-select-lg text-capitalize",
                  modelValue: _ctx.selectedDocumentTypeId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDocumentTypeId) = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.translate('Select Document')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentsType, (document) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: document.id,
                        value: document.id
                      }, _toDisplayString(document.nameEn), 9, _hoisted_11))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_ErrorMessage, { name: "documentTypeId" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.translate('Attachment')), 1),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_Field, {
                  type: "file",
                  accept: "image/*,.pdf,application/pdf,.doc,.docx,.xlsx,.xls,.ppt,.pptx,",
                  name: "attachments",
                  autocomplete: "off",
                  class: "form-control form-control-lg form-control-solid",
                  placeholder: _ctx.translate('Upload Attachment'),
                  multiple: "",
                  ref: "attachmentRef"
                }, null, 8, ["placeholder"]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_ErrorMessage, { name: "attachments" })
                  ])
                ])
              ])
            ]),
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("button", _hoisted_20, _toDisplayString(_ctx.translate('discard')), 1),
            _createElementVNode("button", {
              type: "submit",
              id: "kt_account_profile_details_submit",
              ref: "submitButton",
              class: "btn btn-primary",
              disabled: _ctx.disabledBtn
            }, [
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.translate('saveChanges')), 1),
              _createElementVNode("span", _hoisted_23, [
                _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                _hoisted_24
              ])
            ], 8, _hoisted_21)
          ])
        ]),
        _: 3
      }, 8, ["validation-schema", "onSubmit"]),
      (_ctx.attachmentsData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachmentsData, (attachments, documentTypeId) => {
              return (_openBlock(), _createElementBlock("div", { key: documentTypeId }, [
                _createElementVNode("h3", _hoisted_26, _toDisplayString(documentTypeId), 1),
                _createElementVNode("div", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attachments, (file, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "w-125px h-125px position-relative m-2",
                      style: {"border":"2px solid #eee"}
                    }, [
                      _createElementVNode("a", {
                        href: file.name,
                        target: "_blank"
                      }, [
                        _createElementVNode("img", {
                          class: "w-100 h-100",
                          style: {"object-fit":"cover"},
                          src: file.name
                        }, null, 8, _hoisted_29)
                      ], 8, _hoisted_28),
                      (file.expiryDate)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_30, " Expiry Date:" + _toDisplayString(_ctx.convertDateDDMMYYYY(file.expiryDate)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", {
                        onClick: ($event: any) => (_ctx.removeImage(file.id)),
                        class: "remove-btn"
                      }, "✘", 8, _hoisted_31)
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.previewNewImage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previewNewImage, (image, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "mx-5",
                key: index
              }, [
                _createElementVNode("img", {
                  class: "w-100 h-100 d-inline-block",
                  style: {"object-fit":"cover"},
                  src: image
                }, null, 8, _hoisted_33)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}